<article class="media event media-margin-bottom">
  <ng-content select="ap-media-event-icon"></ng-content>
  <div class="media-body">
    <ng-content select="ap-media-event-title"></ng-content>
    <ng-content select="ap-media-event-content"></ng-content>
  </div>
</article>